import gql from 'graphql-tag'

export const ADD_SUBSCRIBER = gql`
    mutation createSubscriber($email: EmailAddress!){
  createSubscriber(email: $email)
}
`
